import { useState } from "react";
import { Select, Table } from "antd";
import { useGetStores } from "core/services/store/useGetStores";
import { toDateTime } from "core/utils/date-time";

import styles from "./StoresManagementTable.module.scss";

const columns = [
  {
    title: <div className="column">نام فروشگاه</div>,
    render: (store) => {
      return <div>{store?.name ?? "-"}</div>;
    },
  },
  {
    title: <div className="column">لینک فروشگاه</div>,
    render: (store) => {
      return <div>{store?.link ?? "-"}</div>;
    },
  },
  {
    title: <div className="column">آخرین بازدید</div>,
    render: (store) => {
      return <div>{store?.lastVisit ? toDateTime(store.lastVisit) : "-"}</div>;
    },
  },
  {
    title: <div className="column">تاریخ ثبت فروشگاه</div>,
    render: (store) => {
      return (
        <div>
          {store?.registerDatePersian ? store.registerDatePersian : "-"}
        </div>
      );
    },
  },
  {
    title: <div className="column">امتیاز</div>,
    render: (store) => {
      return <div>{store?.rate ?? "-"}</div>;
    },
  },
  {
    title: <div className="column">تعداد فروش</div>,
    render: (store) => {
      return <div>{store?.sellCount ?? "-"}</div>;
    },
  },
  {
    title: <div className="column">تعداد سفارش</div>,
    render: (store) => {
      return <div>{store?.orderCount ?? "-"}</div>;
    },
  },
  {
    title: <div className="column">عملیات</div>,
    dataIndex: "action",
    render: () => {
      return (
        <Select
          defaultValue="نوع عملیات"
          style={{ width: 120 }}
          className={styles["primary"]}
          options={[
            {
              value: "Delete",
              label: "حذف فروشگاه",
            },
            {
              value: "Edit",
              label: "ویرایش کردن",
            },
          ]}
        />
      );
    },
  },
];

const StoresManagementTable = () => {
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");

  const { data, isPending } = useGetStores({
    page: page,
    pageSize: 10,
    inputParams: {
      filters:
        search.trim().length > 0
          ? [{ propertyName: "name", operation: "contains", value: search }]
          : [],
      sort: {
        propertyName: "id",
        ascending: false,
      },
    },
  });

  return (
    <div
      style={{
        marginBottom: 16,
      }}
      className={styles["table-container"]}
    >
      <Table
        locale={{ emptyText: "هیچ داده ای وجود ندارد" }}
        className="table"
        columns={columns}
        dataSource={data?.data?.data ?? []}
        loading={isPending}
        pagination={{
          showSizeChanger: false,
          total: data?.data?.totals ?? 0,
          onChange: (page) => {
            setPage(page);
          },
        }}
      />
    </div>
  );
};
export default StoresManagementTable;
